import axios from 'axios';


export const fetchTransaction = (id) => {
    return axios.get(`/api/transactions/${id}`)
}